import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import landing from "../views/landing.vue";
import login from "../views/login.vue";
import Dashbord from "../views/Dashbord.vue";
import Cookies from "js-cookie";
import { ReadArrayFromCookies, ReadArrayMenuAsLocalStorage } from "@/GlobalPlugin.js";
import appConfig from "@/config/app";
const routes = [
  {
    path: "/",
    redirect: () => {
      return appConfig.showLanding ? "/landing" : "/login";
    },
  },
  {
    path: "/landing",
    name: "landing",
    component: landing,
    beforeEnter(to, from, next) {
          if (appConfig.showLanding==true) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedLandiong",
              },
            });
          }
        },
  },
  {
    path: "/login",
    name: "login",
    component: login,
  },
  {
    path: "/Dashbord",
    name: "Dashbord",
    redirect: { name: "DashbordHome" },
    component: Dashbord,
    children: [
      {
        path: "", // این مسیری است که صفحه پیش‌فرض داخل داشبورد نمایش داده می‌شود
        name: "DashbordHome",
        component: () => import("../views/Forms/DashboardHome"),
      },
      {
        path: "UsersManagement",
        name: "UsersManagement",
        component: () => import("../views/Forms/UsersManagement.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "UsersManagement");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedUsersManagement",
              },
            });
          }
        },
      },
      {
        path: "TaeenSath",
        name: "TaeenSath",
        component: () => import("../views/Forms/TaeenSath.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "TaeenSath");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedTaeenSath",
              },
            });
          }
        },
      },
      {
        path: "Accesses",
        name: "Accesses",
        component: () => import("../views/Forms/Accesses.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "Accesses");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedAccesses",
              },
            });
          }
        },
      },
      {
        path: "RequestRezervTaeenSath",
        name: "RequestRezervTaeenSath",
        component: () => import("../views/Forms/RequestRezervTaeenSath.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "RequestRezervTaeenSath");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedRequestRezervTaeenSath",
              },
            });
          }
        },
      },
      {
        path: "TermFasliManagment",
        name: "TermFasliManagment",
        component: () => import("../views/Forms/TermFasliManagment.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "TermFasliManagment");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedTermFasliManagment",
              },
            });
          }
        },
      },
      {
        path: "ComboManagement",
        name: "ComboManagement",
        component: () => import("../views/Forms/ComboManagement.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "ComboManagement");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedComboManagement",
              },
            });
          }
        },
      },
      {
        path: "ClassManagement",
        name: "ClassManagement",
        component: () => import("../views/Forms/ClassManagement.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "ClassManagement");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedClassManagement",
              },
            });
          }
        },
      },
      {
        path: "CourseManagement",
        name: "CourseManagement",
        component: () => import("../views/Forms/CourseManagement.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "CourseManagement");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedCourseManagement",
              },
            });
          }
        },
      },
      {
        path: "CheckIns",
        name: "CheckIns",
        props: true,
        component: () => import("../views/Forms/CheckIns.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "CheckInClass");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedCheckIns",
              },
            });
          }
        },
      },
      {
        path: "SkillsManagement",
        name: "SkillsManagement",
        props: true,
        component: () => import("../views/Forms/SkillsManagement.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "SkillsManagement");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedSkillsManagement",
              },
            });
          }
        },
      },
      {
        path: "MyClasses",
        name: "MyClasses",
        props: true,
        component: () => import("../views/Forms/MyClasses.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "MyClasses");
          if (find.length > 0) {
            next();
          } else {
            alert();
            next({
              name: "login",
              query: {
                Result: "AccessDeniedMyClasses",
              },
            });
          }
        },
      },
      {
        path: "CheckInTeachers",
        name: "CheckInTeachers",
        props: true,
        component: () => import("../views/Forms/CheckInTeachers.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "CheckInTeachers");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedCheckInTeachers",
              },
            });
          }
        },
      },
      {
        path: "FaragirCheckIn",
        name: "FaragirCheckIn",
        props: true,
        component: () => import("../views/Forms/FaragirCheckIn.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "MyClasses");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedFaragirCheckIn",
              },
            });
          }
        },
      },
      {
        path: "WorkHistory",
        name: "WorkHistory",
        props: true,
        component: () => import("../views/Forms/WorkHistory.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "MyClasses");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedWorkHistory",
              },
            });
          }
        },
      },
      {
        path: "SkillsList",
        name: "SkillsList",
        props: true,
        component: () => import("../views/Forms/SkillsList.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "SkillClass");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedSkillsList",
              },
            });
          }
        },
      },
      {
        path: "TransactionUser",
        name: "TransactionUser",
        props: true,
        component: () => import("../views/Forms/TransactionUser.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "TransactionUser");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedTransactionUser",
              },
            });
          }
        },
      },
      {
        path: "DebitsList",
        name: "DebitsList",
        props: true,
        component: () => import("../views/Forms/DebitsList.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "DebitsList");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedDebitsList",
              },
            });
          }
        },
      },
      {
        path: "SmsManagment",
        name: "SmsManagment",
        props: true,
        component: () => import("../views/Forms/SmsManagment.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "SmsManagment");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedSmsManagment",
              },
            });
          }
        },
      },
      {
        path: "Settings",
        name: "Settings",
        props: true,
        component: () => import("../views/Forms/Settings.vue"),
        beforeEnter(to, from, next) {
          const arr = ReadArrayMenuAsLocalStorage();
          let find = arr.filter((x) => x.routeMenu == "Settings");
          if (find.length > 0) {
            next();
          } else {
            next({
              name: "login",
              query: {
                Result: "AccessDeniedSettings",
              },
            });
          }
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
